import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import InfoIcon from '@material-ui/icons/Info';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#004D7E',
    },
  },
});

const ContactForm = ({ receiver, endpoint, dataprivacy, dataprocessing }) => {

  const privacyModalRef = useRef();
  const processingModalRef = useRef();
  const formRef = useRef();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const [
    {
      title: dPrivacyTitle,
      content: {
        childMarkdownRemark: { html: dPrivacyHtml },
      },
    },
  ] = dataprivacy;
  const [
    {
      title: dProcessingTitle,
      content: {
        childMarkdownRemark: { html: dProcessingHtml },
      },
    },
  ] = dataprocessing;

  const onSubmit = function(evt) {
    evt.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);
    setSubmitStatus(null);

    var formData = new FormData(evt.target);
    var options = {
      method: 'POST',
      body: JSON.stringify({
        name: formData.get('name'),
        mail: formData.get('mail'),
        message: formData.get('message'),
        'dataprivacy-disclaimer': "on",
        'processing-disclaimer': "on",
        receiver: receiver
      }),
    };

    fetch(endpoint, options)
      .then(function(res) {
        if (res.ok) {
          setSubmitStatus('success');
          if (formRef.current) {
            formRef.current.reset();
          }
        } else {
          setSubmitStatus('error');
        }
      })
      .catch(function(err) {
        console.error(err);
        setSubmitStatus('error');
      })
      .finally(function() {
        setIsSubmitting(false);
      });
  };

  return (
    // <MuiThemeProvider theme={theme}>
      <form
        ref={formRef}
        style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}
        onSubmit={onSubmit}
        id="contact-form"
      >
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', flexWrap: 'wrap' }}>
          <Input
            style={{ flex: '1', color: "black", minWidth: '200px' }}
            name="name"
            placeholder="Name*"
            required
            minLength={2}
            maxLength={36}
          />
          <Input
            style={{ flex: '1', color: "black", minWidth: '200px' }}
            name="mail"
            placeholder="Email*"
            required
            type="email"
            pattern={/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/}
            minLength={2}
            maxLength={36}
          />
        </div>
        <Input
          style={{ width: "100%", marginTop: '1rem' }}
          name="message"
          rows={6}
          placeholder="Nachricht*"
          multiline
          required
          minLength={2}
          maxLength={256}
        />
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
            <Checkbox name="dataprivacy-disclaimer" required color="primary" />
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center', marginLeft: '.5rem', cursor: 'pointer' }} onClick={() => privacyModalRef.current.showModal()}>
              <InputLabel htmlFor="dataprivacy-disclaimer" >Zustimmung Datenschutz</InputLabel>
              <InfoIcon color="primary" />
            </div>
            <dialog ref={privacyModalRef} onClick={() => privacyModalRef.current.close()}>
              <h3 style={{ marginLeft: '12px' }}>{dPrivacyTitle}</h3>
              <div dangerouslySetInnerHTML={{ __html: dPrivacyHtml }} />
            </dialog>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
            <Checkbox name="processing-disclaimer" required color="primary" />
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center', marginLeft: '.5rem', cursor: 'pointer' }} onClick={() => processingModalRef.current.showModal()}>
              <InputLabel htmlFor="processing-disclaimer" >Zustimmung Datenverarbeitung</InputLabel>
              <InfoIcon color="primary" />
            </div>
            <dialog ref={processingModalRef} onClick={() => processingModalRef.current.close()}>
              <h3 style={{ marginLeft: '12px' }}>{dProcessingTitle}</h3>
              <div dangerouslySetInnerHTML={{ __html: dProcessingHtml }} />
            </dialog>
          </div>
        </div>
        <Button
          style={{ marginTop: '1rem !important' }}
          type="submit"
          variant="outlined"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <React.Fragment>
              <CircularProgress size={20} style={{ marginRight: '8px' }} />
              WIRD GESENDET...
            </React.Fragment>
          ) : (
            'ABSENDEN'
          )}
        </Button>
        {submitStatus === 'success' && (
          <p style={{ color: 'green', margin: '0.5rem 0' }}>
            Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.
          </p>
        )}
        {submitStatus === 'error' && (
          <p style={{ color: 'red', margin: '0.5rem 0' }}>
            Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
          </p>
        )}
      </form>
    // </MuiThemeProvider>
  );
};

ContactForm.propTypes = {
  receiver: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  dataprivacy: PropTypes.array.isRequired,
  dataprocessing: PropTypes.array.isRequired,
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js